import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { JobInterviewVideoSummary } from "@js/apps/jobs/components/job-interview-video-summary";

import { BidInterviewIcon } from "./bid-interview-icon";

export const BidInterviewQuestions = ({
  openVideo,
  title,
  description,
  videoUrl,
}: {
  openVideo: () => void;
  title: string;
  description: string | null;
  videoUrl: string | null;
}) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <BidInterviewIcon />
        <Typography
          component="h2"
          variant="paragraph"
          size="large"
          sx={{ ml: 1 }}
        >
          Video and transcript
        </Typography>
      </Box>
      <Box sx={{ mb: 4, pb: 3 }}>
        <JobInterviewVideoSummary
          openVideo={openVideo}
          title={title}
          description={description ?? ""}
          videoUrl={videoUrl}
        />
      </Box>
    </Box>
  );
};
